// Module
var code = "<p class=\"fc-dialog-service\">{{errorText}}</p> ";
// Exports
module.exports = code;